const UrlPage = {
  home: '/',
  estudios: '/estudios',
  solConExcel:'/solicitar-con-excel'
};

export default UrlPage;
